<script setup lang="ts">
/**
 * The dataPixies' mark beside the heading of their shelf (`catalogLogos`): the prototype's
 * `icon-pixie`, the website's `logo-datapixies-wand`, drawn in the colour of the text around it,
 * which the shelf sets to the house yellow. Decorative without a `label`.
 */
const props = defineProps<{ label?: string }>();
</script>

<template>
  <svg
    viewBox="0 0 66 73"
    :role="props.label ? 'img' : undefined"
    :aria-label="props.label"
    :aria-hidden="props.label ? undefined : 'true'"
    data-logo
  >
    <path
      d="M54.9052 56.3362C54.9627 55.8872 55.6131 55.8872 55.6698 56.3362C56.1887 60.3989 59.3884 63.5986 63.4511 64.1165C63.9001 64.1741 63.9001 64.8245 63.4511 64.8812C59.3883 65.4 56.1885 68.5996 55.6698 72.6624C55.6131 73.1114 54.9627 73.1114 54.9052 72.6624C54.3873 68.5996 51.1877 65.3999 47.1249 64.8812C46.6759 64.8245 46.6759 64.174 47.1249 64.1165C51.1876 63.5986 54.3872 60.3989 54.9052 56.3362Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38.7235 11.1731C44.8118 5.00762 54.7365 4.93227 60.8866 11.0052C67.0366 17.0781 67.087 27.0027 60.9989 33.1683C58.1623 36.0409 54.4964 37.5859 50.7675 37.8128L50.8436 52.7669L25.4813 52.9573L6.82508 71.5687C5.26105 73.1288 2.728 73.1258 1.16786 71.5618C-0.391924 69.9979 -0.388917 67.4657 1.17469 65.9056L19.4725 47.6526L19.3407 21.6595L34.203 21.5462C34.3615 17.7825 35.8694 14.0637 38.7235 11.1731ZM25.245 27.4974L25.3427 46.9212C25.4049 46.973 25.4656 47.0272 25.5253 47.0833L44.9315 46.9368L44.8329 27.3489L25.245 27.4974ZM56.7509 15.1937C52.9097 11.4007 46.7089 11.4434 42.9022 15.2981C41.1867 17.0354 40.2524 19.2454 40.0936 21.5023L50.6854 21.4222L50.7382 31.9202C52.9578 31.7156 55.1279 30.758 56.8212 29.0433C60.6279 25.1883 60.5921 18.9867 56.7509 15.1937Z"
      fill="currentColor"
    />
    <path
      d="M10.3319 0.395805C10.3999 -0.131945 11.1643 -0.131924 11.2313 0.395805C11.8416 5.17553 15.606 8.94074 20.3856 9.5501C20.9139 9.6178 20.9139 10.3828 20.3856 10.4495C15.606 11.06 11.8416 14.8241 11.2313 19.6038C11.1646 20.132 10.3996 20.132 10.3319 19.6038C9.72264 14.824 5.95838 11.0598 1.1786 10.4495C0.650352 10.3828 0.650352 9.6178 1.1786 9.5501C5.95842 8.94079 9.72272 5.17564 10.3319 0.395805Z"
      fill="currentColor"
    />
  </svg>
</template>
